/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The domain a notification belongs to, used to group notification settings by module.
 */
export enum EnumNotificationModule {
    /**
     * No module assigned.
     */
    NotDefined = 0,
    /**
     * System-level notifications (e.g. forced logout, expiring secrets) not tied to a business module.
     */
    System = 1,
    /**
     * Notifications from the Billing module (invoices, invoice batches).
     */
    Billing = 2,
    /**
     * Notifications from the dynamic export module.
     */
    Exports = 3,
    /**
     * Notifications from the requisitions module (Bestellungen and their Aufträge).
     */
    Requisitions = 4,
    /**
     * Notifications about uploaded documents and attachments.
     */
    Documents = 5,
    /**
     * Notifications about outgoing email delivery.
     */
    Mailing = 6,
}
